/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CoreDeviceStatusDto
 */
export interface CoreDeviceStatusDto {
    /**
     *
     * @type {Date}
     * @memberof CoreDeviceStatusDto
     */
    date?: Date;
    /**
     *
     * @type {string}
     * @memberof CoreDeviceStatusDto
     */
    status?: CoreDeviceStatusDtoStatusEnum;
}

/**
 * @export
 */
export const CoreDeviceStatusDtoStatusEnum = {
    Operational: "Operational",
    Faulted: "Faulted",
} as const;
export type CoreDeviceStatusDtoStatusEnum =
    (typeof CoreDeviceStatusDtoStatusEnum)[keyof typeof CoreDeviceStatusDtoStatusEnum];

/**
 * Check if a given object implements the CoreDeviceStatusDto interface.
 */
export function instanceOfCoreDeviceStatusDto(
    value: object,
): value is CoreDeviceStatusDto {
    return true;
}

export function CoreDeviceStatusDtoFromJSON(json: any): CoreDeviceStatusDto {
    return CoreDeviceStatusDtoFromJSONTyped(json, false);
}

export function CoreDeviceStatusDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): CoreDeviceStatusDto {
    if (json == null) {
        return json;
    }
    return {
        date: json["date"] == null ? undefined : new Date(json["date"]),
        status: json["status"] == null ? undefined : json["status"],
    };
}

export function CoreDeviceStatusDtoToJSON(
    value?: CoreDeviceStatusDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        date: value["date"] == null ? undefined : value["date"].toISOString(),
        status: value["status"],
    };
}
